import { Component, css, html, LitElement } from '@rxdi/lit-html';
/**
 * @customElement divider-component
 */
@Component({
  selector: 'divider-component',
  style: css`
    @keyframes react-reveal {
      0% {
        opacity: 0;
        transform: translate3d(0px, 40px, 0px);
      }
      100% {
        opacity: 1;
        transform: none;
      }
    }
    .home-built-divider {
      display: inline-flex;
      align-items: center;
      margin: 0 auto 32px;
    }
    .divider {
      width: 48px;
    }
    .small-divider {
      width: 8px;
    }
    .circle-icon {
      width: 64px;
      height: 64px;
      border-radius: 32px;
      box-shadow: 0 0 8px 0 rgba(23, 25, 23, 0.2);
      border: 2px solid;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .divider,
    .small-divider {
      height: 2px;
      background: currentColor;
    }
    .home-built-divider .small-orb:first-of-type {
      margin-left: 14px;
    }
    .home-built-divider .small-orb:last-of-type {
      margin-right: 14px;
    }
    .home-built-divider .circle-icon {
      margin: 0 14px;
    }
  `,

  template(this: DividerComponent) {
    return html`
      <div
        class="home-built-divider"
        style="animation-fill-mode: both; animation-name: react-reveal;animation-duration: 700ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; "
      >
        <div class="small-divider"></div>
        <div class="divider"></div>
        <svg class="small-orb" viewBox="0 0 18 18" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 17A8 8 0 109 1a8 8 0 000 16zm4-1.072C11.087 17.033 7.745 14.826 5.536 11 3.326 7.174 3.086 3.176 5 2.072"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            fill-rule="evenodd"
            stroke-linejoin="round"
          ></path>
        </svg>
        <div class="circle-icon">
          <svg viewBox="0 0 34 34" width="34" height="34" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M17 13c8.837 0 16-2.686 16-6s-7.163-6-16-6S1 3.686 1 7s7.163 6 16 6zm0 20c8.837 0 16-2.686 16-6s-7.163-6-16-6-16 2.686-16 6 7.163 6 16 6zM33 7v20M1 27V7m7 25V12"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              fill-rule="evenodd"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
        <svg class="small-orb" viewBox="0 0 18 18" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 17A8 8 0 109 1a8 8 0 000 16zm4-1.072C11.087 17.033 7.745 14.826 5.536 11 3.326 7.174 3.086 3.176 5 2.072"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            fill-rule="evenodd"
            stroke-linejoin="round"
          ></path>
        </svg>
        <div class="divider"></div>
        <div class="small-divider"></div>
      </div>
    `;
  },
})
export class DividerComponent extends LitElement {}
